/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/removeRepo/RemoveRepoPicker.Props" />
import { ExternalGitRepo } from "Wit/Clients/Internal/Contracts/ExternalEvents";

/**
 * Manage repository picker props
 */
export interface IRemoveRepoPickerProps {
    existingRepos?: ExternalGitRepo[];
    onRemoveReposSelectionChanged: (selectedRepos: { [repoNodeId: string]: ExternalGitRepo }) => void;
}
